module.exports = __webpack_public_path__ + "static/media/highway@3x.fb06dca2.png";